import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  calendarList: [],
  selected: {},
  isLoaded: false,
  currentAppointment: {},
  selectedAppointmentId: "",
  bookedDate: "",
  appointmentTreatmentDemandId: "",
};

const bookedAppointmentSlice = createSlice({
  name: "bookedAppointment",
  initialState,
  reducers: {
    setAppointmentTreatmentId: (state, { payload }) => {
      state.appointmentTreatmentDemandId = payload;
    },
    setCalendarList: (state, { payload }) => {
      state.calendarList = payload;
    },
    setChangingAppointment: (state, { payload }) => {
      console.log('[bookedAppointmentSlice] Payload:', payload)
      state.selectedAppointmentId = payload.selectedAppointmentId;
      state.bookedDate = payload.bookedDate;
    },
    clearChangingAppointment: (state) => {
      state.selectedAppointmentId = ""
      state.bookedDate = ""
    },
    setBookedAppointments: (state, { payload }) => {
      state.list = payload;
      state.isLoaded = true;
    },
    setCurrentAppointment: (state, { payload }) => ({
      ...state,
      currentAppointment: payload
    }),
    clearCurrentAppointment: (state, { payload }) => {
      state.currentAppointment = {};
    },
    updateBookedAppointments: (state, { payload }) => {
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },
  },
});

export const { setAppointmentTreatmentId, setChangingAppointment, setBookedAppointments, updateBookedAppointments, setCurrentAppointment, clearCurrentAppointment, setCalendarList } =
  bookedAppointmentSlice.actions;
export default bookedAppointmentSlice.reducer;
